/**
 * ChordWizardButton Component
 * Button to open Chord Wizard modal
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Wand2, Sparkles } from 'lucide-react';

export const ChordWizardButton = ({
  setShowChordWizard,
}) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setShowChordWizard(true)}
      className="p-2 text-zinc-400 hover:text-white hover:bg-indigo-500/20 group relative"
      data-testid="chord-wizard-btn"
      title="Chord Wizard - Generate chord progressions"
    >
      <Wand2 className="w-5 h-5 group-hover:text-indigo-400" />
      <Sparkles className="w-2 h-2 absolute top-1 right-1 text-indigo-400 opacity-0 group-hover:opacity-100 transition-opacity" />
    </Button>
  );
};

export default ChordWizardButton;
